var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-modal',{attrs:{"width":"600px","visible":_vm.visible,"footer":null},on:{"cancel":_vm.handleCancel}},[_c('div',[_c('img',{staticStyle:{"width":"100%","margin-top":"20px"},attrs:{"src":_vm.picVal,"alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }